import React from 'react';
import { connect } from 'react-redux';
import { MdPanoramaFishEye } from 'react-icons/md';
import { Paper, Typography, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useTranslation, withTranslation } from 'react-i18next';

import { UserProps } from '../store/auth/types';
import PulseIcon from '../components/pulse-icon';
import { ApplicationState } from '../store';
import { mapBoundsSelector } from '../store/app/selectors';
import { mapBoundsToBboxPolygon } from '../utils/geo';
import { withUser } from '../hoc';
import { MapBounds } from '../store/app/types';
import { CenteredGrid } from '../components/layout';
import area from '@turf/area';
import { M2_TO_KM2_DENOMINATOR, MIN_OBSERVATION_AREA } from '../constants';
import useCreateObservation from '../hooks/useCreateObservation';

interface StoreProps {
  mapBounds: MapBounds;
}

type Props = StoreProps & UserProps;

export const CreateObservationButton = ({ mapBounds }: Props) => {
  const { t } = useTranslation(['createObservationButton', 'common']);
  const theme = useTheme();
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const create = useCreateObservation();

  const disabled = area(mapBoundsToBboxPolygon(mapBounds)) > MIN_OBSERVATION_AREA * M2_TO_KM2_DENOMINATOR;
  return (
    <CenteredGrid container={true}>
      <CenteredGrid item={true} style={{ marginBottom: '20px', marginLeft: '50px', marginRight: '50px' }}>
        <Paper
          elevation={0}
          style={{ background: 'black', opacity: '80%', padding: 10, color: 'white', textAlign: 'center' }}
        >
          <Typography variant={isSmallerScreen ? 'subtitle2' : 'h6'} color="inherit" align="center">
            {(disabled && t('createObservationButton:areaTooBig')) ||
              t('createObservationButton:createObservation') + '!'}
          </Typography>
        </Paper>
      </CenteredGrid>
      <CenteredGrid item={true} xs={12} id={'create-observation-button'}>
        <PulseIcon disabled={disabled} onClick={create}>
          <MdPanoramaFishEye
            size={70}
            color={useTheme().palette.custom.contrastElement}
            style={{ pointerEvents: 'all' }}
          />
        </PulseIcon>
      </CenteredGrid>
    </CenteredGrid>
  );
};

const mapStoreToProps = (state: ApplicationState): StoreProps => {
  return {
    mapBounds: mapBoundsSelector(state),
  };
};

export default withTranslation(['common', 'createObservationButton'])(
  withUser(connect(mapStoreToProps)(CreateObservationButton)),
);
